import gql from "graphql-tag";
const RunScreenerInputContainerFieldsFragment = gql`
  fragment RunScreenerInputContainerFields on RunScreenerInputContainer {
    objectId
    title
    description
    input
    createdAt
    viewerCanEdit
    selectedIndicators {
      ... on ScreenerIndicatorDetails {
        objectId
        name
        description
        abbreviation
        objectId
        viewerCanSee
      }
      ... on ScreenerStaticIndicator {
        kind
      }
      ... on ScreenerStandardizedIndicator {
        kind
        category
        dataSource
      }
      ... on ScreenerPercentValueChangeIndicator {
        category
        kind
        dataSource
      }
    }
  }
`;
export default RunScreenerInputContainerFieldsFragment;
